import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from "react-router-dom";
import { createContent } from '../../../../redux/actions/content';
import { apiUploadImage } from '../../../../redux/api/fileUpload';
import { apiCreateTag, apiTags } from '../../../../redux/api/tags';
import './ReviewContent.scss';


const ReviewContent = ({ formData, onBack, onSubmit }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const handleCreateContent = async (event, dataOverride) => {
    event && event.preventDefault();
    setLoading(true);
    setSuccessMessage("");

    const data = dataOverride || formData;

    try {
      const payload = {
        title: data.title,
        platform: "ALEXANDRIA",
        mediaType: data.mediaType,
        estimatedDuration: 1,
        isAccessible: data.isAccessible,
        shortDescription: data.shortDescription,
        content: {
          origin_url: data.contentOriginUrl,
          text: data.content || "",
        },
        origin: "NATIONAL",
        tags: [],
        previewImage: "",
        diversityAspects: data.listDiversity,
        communicationVehicle: "",
        isDraft: data.isDraft,
      };

      const existingTags = await apiTags();

      const normalizeText = (text) =>
        text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();

      const normalizeId = (text) =>
        text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase().trim();

      const existingTagMap = new Map(
        existingTags.map((tag) => [normalizeText(tag.name), normalizeId(tag.id)])
      );

      let uniqueTagIds = new Set(data.listTagsID.map(normalizeId));
      let tagsToCreate = [];

      data.listTags.forEach((tag) => {
        const normalizedTag = normalizeText(typeof tag === "string" ? tag : tag.name);
        if (existingTagMap.has(normalizedTag)) {
          uniqueTagIds.add(existingTagMap.get(normalizedTag));
        } else {
          tagsToCreate.push(typeof tag === "string" ? tag : tag.name);
        }
      });

      if (tagsToCreate.length > 0) {
        const createdTags = await Promise.all(
          tagsToCreate.map((tag) => apiCreateTag({ name: tag }))
        );

        createdTags.forEach((tag) => {
          if (tag?.id) {
            uniqueTagIds.add(normalizeId(tag.id));
          }
        });
      }

      payload.tags = Array.from(uniqueTagIds);

      if (data.imageUrl?.startsWith("blob:")) {
        try {
          const blob = await fetch(data.imageUrl).then(res => res.blob());
          const file = new File([blob], "imagem-gerada.png", { type: blob.type });
          const uploadedImage = await apiUploadImage({ file });
          payload.previewImage = uploadedImage.fileUrl;
        } catch (error) {
          console.error("Erro ao carregar imagem blob", error);
        }
      } else if (typeof data.imageUrl === "object" && data.imageUrl instanceof File) {
        try {
          const uploadedImage = await apiUploadImage({ file: data.imageUrl });
          payload.previewImage = uploadedImage.fileUrl;
        } catch (error) {
          console.error("Erro ao carregar imagem File", error);
        }
      }

      await dispatch(createContent(payload));
      sessionStorage.clear("suggestionTags");

      setSuccessMessage("🎉 Conteúdo criado com sucesso!");
      setTimeout(() => history.push("/perfil/meus-conteudos"), 4000);
    } catch (error) {
      setSuccessMessage("❌ Ocorreu um erro. Tente novamente.");
      setTimeout(() => history.push("/criar"), 4000);
    } finally {
      setLoading(false);
    }
  };

  const shouldHideContent = successMessage;

  return (
    <div className="ReviewContent">
      {shouldHideContent ? (
        <div className="feedback-message">
          {loading ? <p>Enviando...</p> : <p>{successMessage}</p>}
        </div>
      ) : (
        <>
          <h2>Revisão Final</h2>
          <p>Confira todas as informações antes de concluir a criação do seu conteúdo.</p>

          <div className="review-section first">
            <h3>Título</h3>
            {loading ? <div className="skeleton skeleton-text" /> : <p>{formData.title || "Não informado"}</p>}
          </div>

          <div className="review-section">
            <h3>URL de Origem</h3>
            {loading ? <div className="skeleton skeleton-text" /> : <p>{formData.contentOriginUrl || "Não informado"}</p>}
          </div>

          <div className="review-section">
            <h3>Conteúdo</h3>
            {loading ? (
              <div className="skeleton skeleton-multiline" />
            ) : (
              <p
                className="review-content-text"
                dangerouslySetInnerHTML={{ __html: formData.content || "Não informado" }}
              />
            )}
          </div>

          <div className="review-section">
            <h3>Tags</h3>
            {loading ? (
              <div className="skeleton skeleton-tags" />
            ) : formData.listTags.length > 0 ? (
              <ul className="tag-list">
                {formData.listTags.map((tag, index) => (
                  <li key={index} className="tag-item">{tag.name || tag}</li>
                ))}
              </ul>
            ) : (
              <p>Sem tags adicionadas.</p>
            )}
          </div>

          <div className="review-section">
            <h3>Imagem Gerada</h3>
            {loading ? (
              <div className="skeleton skeleton-image" />
            ) : formData.imageUrl ? (
              <div className="review-image">
                <img src={formData.imageUrl} alt="Imagem gerada" />
              </div>
            ) : (
              <p>Nenhuma imagem gerada.</p>
            )}
          </div>

          {!loading && <div className="button-group">
            <button className="back-button" onClick={onBack} disabled={loading}>
              Voltar
            </button>
            <button className="continue-button" onClick={handleCreateContent} disabled={loading}>
              Finalizar
            </button>
          </div>}
        </>
      )}
    </div>

  );
};

export default ReviewContent;
